import { render } from "./BioContent.vue?vue&type=template&id=09847f7d&scoped=true"
import script from "./BioContent.vue?vue&type=script&lang=js"
export * from "./BioContent.vue?vue&type=script&lang=js"

import "./BioContent.vue?vue&type=style&index=0&id=09847f7d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09847f7d"]])

export default __exports__